import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[appDateMask]'
})
export class DateMaskDirective {

    constructor(private el: ElementRef) { }

    @HostListener('input', ['$event'])
    onInput(event: any): void {
        const input = event.target;
        const previousValue = input.value;
        let value = previousValue.replace(/\D/g, ''); // Solo números
        
        if (value.length > 8) value = value.substring(0, 8);

        let formatted = '';
        if (value.length > 0) {
            formatted = value.substring(0, 2);
            if (value.length > 2) {
                formatted += '/' + value.substring(2, 4);
                if (value.length > 4) {
                    formatted += '/' + value.substring(4, 8);
                }
            }
        }

        // Solo actualizamos si el valor cambió para evitar loops y problemas de cursor
        if (previousValue !== formatted) {
            const selectionStart = input.selectionStart;
            
            // Calculamos cuánto se desplazará el cursor por las barras agregadas
            const slashesBefore = (previousValue.substring(0, selectionStart).match(/\//g) || []).length;
            const slashesAfter = (formatted.substring(0, selectionStart).match(/\//g) || []).length;
            const addedSlashes = slashesAfter - slashesBefore;
            
            input.value = formatted;
            
            // Reposicionamos el cursor
            const newPosition = selectionStart + addedSlashes;
            input.setSelectionRange(newPosition, newPosition);
            
            // Disparamos un evento de input nativo para que Angular Forms sepa que cambió
            // pero sin forzar manualmente el setValue que causaba el conflicto
            input.dispatchEvent(new Event('input'));
        }
    }
}
